import {
    EDIT_COUNTRY_FAILED,
    EDIT_COUNTRY_LOADING,
    EDIT_COUNTRY_SUCCESS,
  } from "../types";
  
  const initialState = {
    loading: false,
    error: null,
    status: null,
  };
  
  export const editCountryReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any }
  ) => {
    switch (action.type) {
      case EDIT_COUNTRY_LOADING:
        return {
          ...state,
          loading: action.loading,
          error: null,
          status: null,
        };
      case EDIT_COUNTRY_SUCCESS:
        return {
          ...state,
          loading: false,
          status: action.payload,
        };
      case EDIT_COUNTRY_FAILED:
        return {
          ...state,
          loading: false,
          error: action.error,
          status: null,
        };
     
      default:
        return state;
    }
  };
  